import React from 'react';

var typeOf = function typeOf(_ref) {
  var childType = _ref.displayName;
  return function (props, propName, componentName) {
    var error;
    var prop = props[propName];
    React.Children.forEach(prop, function (child) {
      if (child.type.displayName !== childType) {
        error = new Error("\"" + componentName + "\" only accepts children of type \"" + childType + "\".");
      }
    });
    return error;
  };
};

export default typeOf;